import { Component, OnInit, Inject } from '@angular/core';
import { AdminService } from '../services/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { Resource } from '../../shared/models/resource.interface';
import { ResourceType } from '../../shared/models/resource.type.interface';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericDialogData } from '../models/generic.dialog.interface';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-resource',
  templateUrl: './resource.component.html',
  styleUrls: ['./resource.component.scss']
})
export class ResourceComponent implements OnInit {

  constructor(private adminService: AdminService, public dialogRef: MatDialogRef<ResourceComponent>, @Inject(MAT_DIALOG_DATA) public data: GenericDialogData) { }
  resource: Resource;
  resourceTypes: ResourceType[];
  errors: string;
  isRequesting: boolean;
  ngOnInit() {
    let resourceId: string = this.data.id;
    let dealerId = this.adminService.getDealerId();

    if (resourceId == null) {
      this.resource = {} as Resource;
      this.resource.resource_IsActive = true;
      this.resource.resource_IsCheckOutReq = false;
    }
    else {
      this.adminService.getResource(resourceId)
        .subscribe({
          next: (data) => {
            this.resource = data;
          }
        });
    }

    this.adminService.getResourceTypes(dealerId)
      .subscribe({
        next: (data) => {
          this.resourceTypes = data;
        }
      });
  }

  saveResource(form: NgForm) {
    console.log('in resources onSubmit: ', this.resource);
    this.errors = '';
    if (form.valid) {
      this.isRequesting = true;

      let dealerId = this.adminService.getDealerId();
      this.resource.dealer_ID = dealerId;

      this.adminService.saveResource(this.resource)
        .pipe(finalize(() => this.isRequesting = false))
        .subscribe({
          next: (result) => {
          if(result) {
            this.dialogRef.close();
          }
        },
          error: (error: string) => {
            this.errors = error;
          }
        });
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
